export default __webpack_public_path__ + "08f2719ba26ed7ad69c72af525ecb757.png";